export const defaultFont = {
  fontFamily: 'Fibel Nord',
  fontSize: '1',
}

export const defaultCalcLayout = 'numpad'

export const studyStatus = [
  { id: 0, label: 'nicht freigegeben', colorClass: 'text-danger' },
  { id: 1, label: 'freigegeben', colorClass: 'text-warning' },
  { id: 2, label: 'gestartet', colorClass: 'text-success' },
  { id: 3, label: 'beendet', colorClass: 'text-primary' },
]
